/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ClientCompanyRemoveMemberRequest
 */
export interface ClientCompanyRemoveMemberRequest {
    /**
     * 
     * @type {string}
     * @memberof ClientCompanyRemoveMemberRequest
     */
    transferAccountId?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientCompanyRemoveMemberRequest
     */
    companyId: string;
}

/**
 * Check if a given object implements the ClientCompanyRemoveMemberRequest interface.
 */
export function instanceOfClientCompanyRemoveMemberRequest(value: object): value is ClientCompanyRemoveMemberRequest {
    if (!('companyId' in value) || value['companyId'] === undefined) return false;
    return true;
}

export function ClientCompanyRemoveMemberRequestFromJSON(json: any): ClientCompanyRemoveMemberRequest {
    return ClientCompanyRemoveMemberRequestFromJSONTyped(json, false);
}

export function ClientCompanyRemoveMemberRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClientCompanyRemoveMemberRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'transferAccountId': json['transferAccountId'] == null ? undefined : json['transferAccountId'],
        'companyId': json['companyId'],
    };
}

export function ClientCompanyRemoveMemberRequestToJSON(value?: ClientCompanyRemoveMemberRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'transferAccountId': value['transferAccountId'],
        'companyId': value['companyId'],
    };
}

